import * as React from "react"

import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { cn } from "@/lib/utils"

export interface TradeLogShowStatsToggleProps {
  id: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  hideOnMobile?: boolean
  className?: string
}

/** shadcn Switch demo — https://ui.shadcn.com/docs/components/radix/switch */
export function TradeLogShowStatsToggle({
  id,
  checked,
  onCheckedChange,
  hideOnMobile = false,
  className,
}: TradeLogShowStatsToggleProps): React.ReactElement {
  return (
    <div
      data-show-stats-toggle=""
      className={cn(
        "flex shrink-0 items-center gap-2",
        hideOnMobile && "hidden md:flex",
        className
      )}
    >
      <Label htmlFor={id} className="mb-0 leading-none">
        Show Stats
      </Label>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  )
}
